// extracted by mini-css-extract-plugin
export default {"messenger":"messenger-module__messenger___EMG6C","messenger__image":"messenger-module__messenger__image___tcWjA"};